import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import ShowDocuments from './ShowDocuments'

export default class Layout extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  state = { all: true }

  renderDocuments() {
    return (
      <div className={styles.documents}>
        <div className={styles.allDocuments}>
          <div className="row">
            <div
              onClick={() =>
                this.setState({
                  all: true,
                  pending: false,
                  signed: false,
                  own: false,
                  viewer: false,
                  archi: false,
                  temp: false
                })
              }
              className={this.state.all ? styles.each1Blue : styles.each1}
            >
              ({this.props.user.documents}) All{' '}
            </div>
            <div
              onClick={() =>
                this.setState({
                  all: false,
                  pending: true,
                  signed: false,
                  own: false,
                  viewer: false,
                  archi: false,
                  temp: false
                })
              }
              className={this.state.pending ? styles.each2Blue : styles.each2}
            >
              ({this.props.user.pending}) Pending
            </div>
            <div
              onClick={() =>
                this.setState({
                  all: false,
                  pending: false,
                  signed: true,
                  own: false,
                  viewer: false,
                  archi: false,
                  temp: false
                })
              }
              className={this.state.signed ? styles.each3Blue : styles.each3}
            >
              ({this.props.user.sign}) Signed{' '}
            </div>
            <div
              onClick={() =>
                this.setState({
                  all: false,
                  pending: false,
                  signed: false,
                  own: true,
                  viewer: false,
                  archi: false,
                  temp: false
                })
              }
              className={this.state.own ? styles.each4Blue : styles.each4}
            >
              ({this.props.user.mySign}) OwnSign{' '}
            </div>
            <div
              onClick={() =>
                this.setState({
                  all: false,
                  pending: false,
                  signed: false,
                  own: false,
                  viewer: true,
                  archi: false,
                  temp: false
                })
              }
              className={this.state.viewer ? styles.each5Blue : styles.each5}
            >
              ({this.props.user.view}) Viewer{' '}
            </div>
            <div
              onClick={() =>
                this.setState({
                  all: false,
                  pending: false,
                  signed: false,
                  own: false,
                  viewer: false,
                  archi: true,
                  temp: false
                })
              }
              className={this.state.archi ? styles.each6Blue : styles.each6}
            >
              ({this.props.user.archive}) Archived{' '}
            </div>
            <div
              onClick={() =>
                this.setState({
                  all: false,
                  pending: false,
                  signed: false,
                  own: false,
                  viewer: false,
                  archi: false,
                  temp: true
                })
              }
              className={this.state.temp ? styles.each7Blue : styles.each7}
            >
              ({this.props.user.templates}) Templates{' '}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        {' '}
        {this.renderDocuments()}
        <ShowDocuments state={this.state} userId={this.props.user._id} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/UserInformation/Layout/index.js